import { Typography } from "@mui/material";
import { FlexColBox } from "../../common/components";
import { palette, spacing } from "../../styles/theme";
import { User } from "../../types";
import { useTranslation } from "react-i18next";

interface Props {
  userDetails: User;
  fromAdmin?: boolean;
}

const YourContactBox = ({ userDetails, fromAdmin }: Props) => {
  const { t } = useTranslation();
  return (
    <FlexColBox gap="8px">
      {fromAdmin ? (
        <Typography variant="textRegularBold">
          {t("order.order_placed_by")}
        </Typography>
      ) : (
        <Typography variant="textSm" color={palette.grey.primary}>
          {t("order.contact")}
        </Typography>
      )}
      <FlexColBox gap={{ xs: spacing.xsMobile, lg: spacing.xsDesktop }}>
        <Typography
          variant="textRegular"
          color={fromAdmin ? palette.grey.primary : palette.grey.nearBlack}
        >
          {userDetails && `${userDetails.firstName} ${userDetails.lastName}`}
        </Typography>
        {userDetails && (
          <Typography
            variant="textRegular"
            color={fromAdmin ? palette.grey.primary : palette.grey.nearBlack}
          >
            {userDetails.email}
          </Typography>
        )}
      </FlexColBox>
    </FlexColBox>
  );
};

export default YourContactBox;
